import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Routes, HashRouter as Router, Navigate } from 'react-router-dom'
import { init } from './util.js'

import './bootstrap-custom.scss';

import Menu from './Menu';
import Sources from './Sources';
import Filters from './Filters';
import Endpoints from './Endpoints';
import Server from './Server';
import SignIn from './SignIn';
import RequireAuth from './RequireAuth';
import TestFeed from './TestFeed';
import Settings from './Settings';
import Users from './Users';
import Footer from './components/Footer';

// Use environment variable for API URL
// If REACT_APP_BACKEND_URL is explicitly set to empty string, use current origin
// Otherwise fall back to localhost with PORT_HTTP_HOST
const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
const apiUrl = envBackendUrl !== undefined && envBackendUrl !== null
    ? envBackendUrl
    : `http://localhost:${process.env.PORT_HTTP_HOST || '9011'}`;
// Don't add /api here as it's included in the nginx location
console.log('Environment REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
console.log('Using API URL:', apiUrl);
init(apiUrl);

const routing = (
    <Router>
        <div style={{ paddingBottom: '40px' }}>  {/* Add padding to prevent content from being hidden by footer */}
            <Routes>
                <Route path="/signin" element={<SignIn />} />
                <Route path="/" element={<Navigate to="/sources" />} />

                <Route path="/sources" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Sources />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/filters" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Filters />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/endpoints" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Endpoints />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/server" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Server />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/test-feed" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <TestFeed />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/settings" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Settings />
                            </div>
                        </>
                    </RequireAuth>
                } />

                <Route path="/users" element={
                    <RequireAuth>
                        <>
                            <Menu />
                            <div className="container">
                                <Users />
                            </div>
                        </>
                    </RequireAuth>
                } />
            </Routes>
            <Footer />
        </div>
    </Router>
)

ReactDOM.render(routing, document.getElementById('root'));
